import packageJson from '../../package.json';

export const environment = {
  production: false,
  appName: 'Heat Exchanger Analysis Tool',
  version: packageJson.version,
  auth: {
    clientId: '007bc79f-07d7-45fa-8016-bc3b910f211b',
    authority: 'https://login.microsoftonline.com/chevron.onmicrosoft.com',
    redirectUri: 'https://heat-dev.azure.chevron.com',
    postLogoutRedirectUri: 'https://heat-dev.azure.chevron.com/auth/logout'
  },
  protectedResourceMap: [
    ['https://heat-api-dev.azure.chevron.com/api', ['https://heatex-test.azure.chevron.com/user_impersonation']],
    [
      'https://heat-function-app.azurewebsites.net/api/HEX_Tool',
      ['https://heatex-test.azure.chevron.com/user_impersonation']
    ]
  ],
  apiEndpoint: 'https://heat-api-dev.azure.chevron.com/api',
  functionAppEndPoint: 'https://heat-function-app.azurewebsites.net/api/HEX_Tool',
  scope: 'https://heatex-test.azure.chevron.com/user_impersonation',
  appInsights: {
    instrumentationKey: 'f8070c25-0712-43af-8f36-3e169209d9f8',
    connectionString:
      'InstrumentationKey=2c27a152-726b-40db-9119-62ef7653d98d;IngestionEndpoint=https://southcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=d0c9dcac-1572-47d5-ba4a-723934aca224'
  }
};
